import { getCallable } from "../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import {
    RecordIconSelectionRequest, RecordIconSelectionResponse,
    GetUserRecommendationsRequest, GetUserRecommendationsResponse,
} from "./types";

export { apiName };

const recordIconSelection = getCallable<RecordIconSelectionRequest, RecordIconSelectionResponse>(apiName, "recordIconSelection", {
    ...endpoints.recordIconSelection,
    composer: request => {
        return {
            url: `/icons/${encodeURIComponent(request.userId)}/record`,
            options: {
                method: "POST",
                body: JSON.stringify({ iconKey: request.iconKey })
            }
        };
    }
});

const getUserRecommendations = getCallable<GetUserRecommendationsRequest, GetUserRecommendationsResponse>(apiName, "getUserRecommendations", {
    ...endpoints.getUserRecommendations,
    composer: request => {
        return {
            url: `/icons/${encodeURIComponent(request.userId)}/recommendations`,
            options: {
                method: "GET"
            }
        };
    }
});

export const callables = {
    recordIconSelection,
    getUserRecommendations,
};
